import React from "react";

const PaymentList = React.lazy(() => import("./PaymentList"));

export default {
  list: PaymentList,
};
